export default __webpack_public_path__ + "static/media/standard_08.f397d985.png";